import { useEffect, useState } from "react";
import { cachedGet, invalidateCached } from "../lib/sharedData";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";

export const clearOnboardingCache = () => invalidateCached("/onboarding/state");
export async function fetchOnboardingState(force = false) {
  return cachedGet("/onboarding/state", 5 * 60000, { force }).catch(() => null);
}

// Redirects agents/admins who still need onboarding to the wizard.
export function OnboardingGate({ user }) {
  const nav = useNavigate();
  const loc = useLocation();
  useEffect(() => {
    if (!user || !["agent", "admin"].includes(user.role) || loc.pathname.startsWith("/onboarding")) return;
    fetchOnboardingState().then((s) => { if (s?.needs_onboarding) nav("/onboarding", { replace: true }); });
  }, [user, loc.pathname, nav]);
  return null;
}

// Dashboard/Today banner listing skipped steps until they are finished.
export function OnboardingChecklist() {
  const t = useT();
  const [state, setState] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("ob-checklist-hidden") === "1");
  useEffect(() => { fetchOnboardingState(true).then(setState); }, []);
  const skipped = state?.checklist || state?.skipped || [];
  if (hidden || !state?.completed_at || skipped.length === 0) return null;
  return (
    <div className="mb-6 rounded-xl border border-orange-200 bg-orange-50/60 px-4 py-3" data-testid="onboarding-checklist">
      <div className="flex items-center justify-between">
        <div className="text-sm font-semibold text-slate-900">{t("Setup afmaken")} <span className="text-xs font-medium text-slate-500 tabular-nums">{skipped.length} {t("open")}</span></div>
        <button onClick={() => { sessionStorage.setItem("ob-checklist-hidden", "1"); setHidden(true); }} className="text-slate-400 hover:text-slate-700" data-testid="onboarding-checklist-hide" aria-label={t("Verbergen")}><X size={14} /></button>
      </div>
      <div className="mt-2 divide-y divide-orange-100">
        {skipped.map((s) => (
          <Link key={s.key} to={`/onboarding?step=${s.key}`} className="flex items-center justify-between py-2 text-sm text-slate-700 hover:text-slate-900" data-testid={`onboarding-checklist-${s.key}`}>
            <span>{t(s.title)}{s.wizard === false && <span className="ml-2 text-xs text-slate-400">{t("aanbevolen")}</span>}</span><ArrowRight size={14} className="text-slate-400" />
          </Link>
        ))}
      </div>
    </div>
  );
}
